'use strict';

angular.module('licensure.services')
    .factory('Clinicians', ['$http', '$q', 'Documents', 'Upload', function ($http, $q, Documents, Upload) {
        var importClinicians = function (document_id, service_id) {
            var d = $q.defer();

            $http.post(apiLocation + '/api/clinicians/importClinicians/' + document_id + '/' + service_id)
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.resolve(null);
                });

            return d.promise;
        }

        var saveFileUpload = function (document_id, response_id) {
            var d = $q.defer();

            $http.post(apiLocation + '/api/clinicians/saveFileUpload/' + document_id + '/' + response_id)
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.resolve(null);
                });

            return d.promise;
        }

        var getDocumentByResponseID = function (responseID) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/clinicians/getDocumentByResponseID', {
                    params: {
                        responseID: responseID
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.resolve(null);
                });

            return d.promise;
        }

        return {
            downloadExcel: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/clinicians/getExcel', {
                        params: {
                            serviceID: id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            saveElement: function (fileUpload, licenseRequestId, responseId, formCompleted) {
                var d = $q.defer();

                if (fileUpload[0] != null && fileUpload[0].file_updated && fileUpload[0].file_content != null && fileUpload[0].file_name != null && !fileUpload[0].saved) {
                    //Upload document
                    Documents.upload({
                        file: Upload.dataUrltoBlob(fileUpload[0].file_content, fileUpload[0].file_name),
                        name: fileUpload[0].file_name
                    }, licenseRequestId).then(function (document) {
                        if (document != null) {
                            saveFileUpload(document.id, responseId).then(function () {
                                if (formCompleted) {
                                    //Form submitted - import clinicians
                                    importClinicians(document.id, fileUpload[0].service_id).then(function () {
                                        d.resolve();
                                    })
                                } else {
                                    d.resolve();
                                }
                            })
                        }
                    })
                }
                else if (fileUpload[0] != null && fileUpload[0].saved && fileUpload[0].document_id == null && fileUpload[0].service_id != null && formCompleted)
                {
                    //Document already uploaded and form submitted, but form does not have document id
                    getDocumentByResponseID(responseId).then(function (documentId) {
                        if (documentId !== null && documentId !== undefined && documentId !== '') {
                            importClinicians(documentId, fileUpload[0].service_id).then(function () {
                                d.resolve();
                            })
                        } else {
                            d.resolve();
                        }
                    })
                }
                else if (fileUpload[0] != null && fileUpload[0].document_id != null && fileUpload[0].service_id != null && formCompleted)
                {
                    //Document already uploaded, form submitted - import clinicians
                    importClinicians(fileUpload[0].document_id, fileUpload[0].service_id).then(function () {
                        d.resolve();
                    })
                }
                else {
                    //No document uploaded or document uploaded already but form not submitted
                    d.resolve();
                }
                
                return d.promise;
            },

            getDocumentByResponseID: function (responseID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/clinicians/getDocumentByResponseID', {
                        params: {
                            responseID: responseID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
;